import React from 'react';
import { ProviderHome } from './ProviderHome';

export function InspectorHome() {
  return <ProviderHome providerType="inspector" />;
}
